import CourseDataPromiseFactories from 'pages/open-course/common/data/courseData';
import Course from 'pages/open-course/common/models/course';

const getCourse = (courseDataPromise: $TSFixMe, options: $TSFixMe = {}) =>
  courseDataPromise.then((courseData: $TSFixMe) => {
    const course = new Course(courseData, { parse: true });

    if (options.rawData) {
      return courseData;
    }

    return course;
  });

export const fromSlug = (courseSlug: $TSFixMe, options?: $TSFixMe) =>
  getCourse(CourseDataPromiseFactories.fromSlug(courseSlug), options);

export const fromId = (courseId: $TSFixMe) => getCourse(CourseDataPromiseFactories.fromId(courseId));

export default { fromSlug, fromId };
